import React, { useState } from 'react';
import legalContent from '../../content/fa/legal.json';

const content = legalContent.propertyPublishing;

function AgreementPaymentPublishStep({ onSubmit, initialData = {}, onPreviousStep }) {
  const [agreeTerms, setAgreeTerms] = useState(initialData.agree_terms || false);
  const [agreePrivacy, setAgreePrivacy] = useState(initialData.agree_privacy || false);
  const [error, setError] = useState(null);

  const handleContinue = () => {
    setError(null);

    if (!agreeTerms) {
      setError(content.terms.error);
      return;
    }

    if (!agreePrivacy) {
      setError(content.privacy.error);
      return;
    }

    onSubmit({
      agree_terms: agreeTerms,
      agree_privacy: agreePrivacy
    });
  };

  return (
    <div className="agreement-payment-publish-step">
      <div className="step-header">
        <h3>{content.heading}</h3>
        <p>{content.description}</p>
      </div>

      {error && (
        <div className="error-message">{error}</div>
      )}

      <div className="agreements-section">
        <div className="agreement-box">
          <h4>{content.terms.title}</h4>
          <div className="agreement-content">
            <p>{content.terms.intro}</p>
            <ul>
              {content.terms.items.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </div>
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={agreeTerms}
              onChange={(e) => setAgreeTerms(e.target.checked)}
            />
            <span>{content.terms.agreementLabel}</span>
          </label>
        </div>

        <div className="agreement-box">
          <h4>{content.privacy.title}</h4>
          <div className="agreement-content">
            <p>{content.privacy.intro}</p>
            <ul>
              {content.privacy.items.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </div>
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={agreePrivacy}
              onChange={(e) => setAgreePrivacy(e.target.checked)}
            />
            <span>{content.privacy.agreementLabel}</span>
          </label>
        </div>
      </div>

      <div className="info-box">
        {content.confirmation}
      </div>

      <div className="navigation-buttons">
        <button
          type="button"
          onClick={handleContinue}
          className="submit-button"
          disabled={!agreeTerms || !agreePrivacy}
        >
          {content.submitLabel}
        </button>
        <button
          type="button"
          onClick={onPreviousStep}
          className="previous-button"
        >
          {content.backLabel}
        </button>
      </div>
    </div>
  );
}

export default AgreementPaymentPublishStep;
